import FontFaceObserver from 'fontfaceobserver';

import application from 'application';

export function getFabricObjectBoundingClientRect(canvas, fabricObject) {

  const canvasEl = canvas.getElement(); // Get the canvas DOM element
  const canvasRect = canvasEl.getBoundingClientRect(); // Get canvas position and size on page
  fabricObject.setCoords();
  // Get the object's bounding rectangle relative to the canvas
  const objectRect = fabricObject.getBoundingRect(true);
  var zoom = canvas.getZoom();
  var viewportMatrix = canvas.viewportTransform;

  const top = canvasRect.top + ((objectRect.top - viewportMatrix[5]) / zoom);
  const left = canvasRect.left + ((objectRect.left - viewportMatrix[4]) / zoom);
  const width = objectRect.width / zoom;
  const height = objectRect.height / zoom;
  const boundingClientRect = {
    top,
    left,
    width,
    height,
    right: canvasRect.left + left + width,
    bottom: canvasRect.top + top + height,
  };

  return boundingClientRect;
}

export function buildToobarConfiguration(configuration) {

  const fabricCanvas = configuration.fabricCanvas;
  const activeObject = configuration.activeObject;

  function postChange() {
    fabricCanvas.renderAll();
    fabricCanvas.fire('object:modified', {
      target: activeObject
    });
  }

  const toolbarConfiguration = {
    anchor: configuration.anchor,
    heading: {
      h1: false,
      h2: false,
      h3: false,
      h4: false,
      h5: false,
      h6: false
    },
    marks: {
      bold: activeObject.fontWeight === 'bold',
      italic: activeObject.fontStyle === 'italic',
      underline: false,
      strikeThrough: false,
    },
    color: {
      text: '',
      background: ''
    },
    font: {
      family: '',
      size: '',
      weight: ''
    },
    lineHeight: '',
    alignment: {
      left: false,
      center: false,
      right: false
    },
    callbacks: {
      onH1Change: (value) => {},
      onH2Change: (value) => {},
      onH3Change: (value) => {},
      onH4Change: (value) => {},
      onH5Change: (value) => {},
      onH6Change: (value) => {},
      onBoldChange: (value) => {
        if (value === true) {
          activeObject.set({ fontWeight: 'bold' });
        } else {
          activeObject.set({ fontWeight: 'normal' });
        }
        postChange();
      },
      onItalicChange: (value) => {
        if (value === true) {
          activeObject.set({ fontStyle: 'italic' });
        } else {
          activeObject.set({ fontStyle: 'normal' });
        }
        postChange();
      },
      onUnderlineChange: (value) => {
        if (value === true) {
          activeObject.set({ underline: true });
        } else {
          activeObject.set({ underline: false });
        }
        postChange();
      },
      onStrikeThroughChange: (value) => {},
      onTextColorChange: (value) => {},
      onBackgroundColorChange: (value) => {},
      onFontFamilyChange: (value) => {},
      onFontSizeChange: (value) => {},
      onFontWeightChange: (value) => {},
      onLineHeightChange: (value) => {},
      onAlignmentLeftChange: (value) => {},
      onAlignmentCenterChange: (value) => {},
      onAlignmentRightChange: (value) => {}
    },
    onClose() {}
  };

  return toolbarConfiguration;

}

function loadSystemFont(font) {

  application.externalFontFamiliesManager.activateFontFamilies({
    [font.name]: 1
  });

}

function loadExternalFont(font) {
  const link = document.createElement('link');
  link.href = font.url;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
}

export function loadFont(font) {

  if (application.system.isExternalFontFamily(font.name) === true) {
    loadSystemFont(font);
  } else {
    loadExternalFont(font);
  }

  const fontObserver = new FontFaceObserver(font.name, {
    weight: font.weight,
    style: font.style
  });

  return fontObserver.load(null, 5000)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      return;
    });

}

export async function loadFonts(fonts) {
  const fontPromises = fonts.map(font => loadFont(font));
  await Promise.all(fontPromises);
}

export function dataURLToFile(dataURL, filename) {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}